import { InvitationCodeService } from './service/Invitation-code.service';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import Multiselect from 'vue-multiselect';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import BootstrapVue from 'bootstrap-vue';
import IconsPlugin, { ToastPlugin } from 'bootstrap-vue';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import * as customDirective from './shared/directives/ds-directive';
import InfiniteLoading from 'vue-infinite-loading';
import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ConfigurationService from '@/admin/configuration/configuration.service';
import RegisterService from './account/register/register.service';
import UserManagementService from '@/admin/user-management/user-management.service';
import LoginService from './account/login.service';
import PhoneService from '@/account/phone.service';
import AccountService from './account/account.service';
import ConnectomeService from '@/entities/connectome/connectome.service';
import ScrapboardManagerService from '@/entities/new-learning-center/scrapboard-manager.service';
import AskGooverService from '@/service/ask-goover.service';
// import 'bootstrap/dist/css/bootstrap.css';
import { isJwtExpired } from 'jwt-check-expiration';
// import Hotjar from './hotjar';

import 'echarts';
// Vuelidate
import Vuelidate from 'vuelidate';
import 'vuelidate/dist/vuelidate.min';

import '../content/scss/vendor.scss';
import TranslationService from '@/locale/translation.service';

// import UserOAuth2Service from '@/entities/user/user.oauth2.service';

import FeedService from '@/core/home/feed/feed.service';
import PublicService from '@/service/public.service';
import PeopleService from '@/core/home/people/people.service';
import Fragment from 'vue-fragment';
import { RecentSearchService } from '@/service/recent-search.service';
import { PrincipalService } from '@/service/principal.service';
import WebsocketService from '@/service/websocket.service';
import axios from 'axios';
import { UserSettingService } from '@/service/usersetting.service';
import BriefingService from '@/service/briefing.service';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import UserMyPageService from '@/service/userMyPage.service';
import vueAwesomeCountdown from 'vue-awesome-countdown';
import ClickOutside from '@/../content/js/clickOutside';
import ReportShareService from '@/service/report-share.service';
import { checkIsGuestAccount, initGuestAccount } from '@/util/guest-util';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import VueLazyload from 'vue-lazyload';
import { ROUTE_NAME_NOT_CREATE_GUEST, ROUTE_NAME_REQUIRED_ACCOUNT } from '@/constants';
import PaymentService from '@/service/payment.service';
import RecapService from '@/service/recap.service';
import ScrapAgentService from '@/service/scrap-agent.service';

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
customDirective.initDirective(Vue);
Vue.use(Vue2Filters);
Vue.use(ToastPlugin);
Vue.use(Vuelidate);
Vue.use(Fragment.Plugin);
Vue.use(vueCustomScrollbar);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component('multiselect', Multiselect);
Vue.use(VueAwesomeSwiper);
Vue.use(vueAwesomeCountdown, 'vac');
Vue.use(VueLazyload, {
  loading: '@/content/images/images_v3/common/go-empty-thumb-sz176.png',
  error: '@/content/images/images_v3/common/go-empty-thumb-sz176.png',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
      retry: 2,
    },
  },
});

Vue.prototype.$queryClient = queryClient;
Vue.use(VueQueryPlugin, { queryClient });

// Vue.use(Hotjar, {
//   id: process.env.NODE_ENV === 'development' ? '5255591' : '5247948',
//   version: '6',
// });

Vue.component('infinite-loading', InfiniteLoading);
const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);
Vue.directive('click-outside', ClickOutside);
let tokenTimer;

const websocketService = new WebsocketService(router, store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);
const registerService = new RegisterService();

export function clearStorage() {
  const storageItems = [
    'stock-codes',
    'currentLanguage',
    'ds-connectome',
    'ds-authenticationToken',
    'card-data',
    'requested-url',
    'conversationId',
  ];
  storageItems.forEach(item => {
    if (localStorage.getItem(item)) {
      localStorage.removeItem(item);
    }
    if (sessionStorage.getItem(item)) {
      sessionStorage.removeItem(item);
    }
  });

  store.commit('logout');
}

const moveToMobileIntroduce = (name: string, next: any, route?: string) => {
  const userAgent = navigator.userAgent || navigator.vendor;
  const isAndroid = /Android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isMobileBrowser = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isKeepAccess = ['ReportDetail', 'Register', 'MobileView', 'IntroduceMobile', 'Guide', 'Recap'].includes(name);
  const isMoreAccess = ['/my-briefing', '/my-page', '/pricing-plan'].some(path => route.includes(path));

  if (!isKeepAccess && isMobileBrowser) {
    const linkAppStore = 'https://apps.apple.com/kr/app/goover-ai/id6498977274';
    let linkCHPlay = 'https://play.google.com/store/apps/details?id=com.goover.ai&hl=en';
    const lang = localStorage.getItem('currentLanguage');
    if (lang == 'ko') {
      linkCHPlay = 'https://play.google.com/store/apps/details?id=com.goover.ai&hl=ko';
    }

    if (isAndroid) {
      window.location.href = linkCHPlay;
    } else if (isIOS) {
      window.location.href = linkAppStore;
    } else {
      next('/mobile-down'); // others OS
    }
    return;
  }
  next();
};

function hideModal() {
  // get modal is opening
  const openModals = document.querySelectorAll('.modal.show');

  openModals.forEach(modal => {
    const closeBtn = modal.querySelector('[data-dismiss="modal"]');
    if (closeBtn && (closeBtn.tagName === 'BUTTON' || closeBtn.tagName === 'A')) {
      // @ts-ignore
      closeBtn.click();
    }
  });
}

async function createGuestAccount() {
  const guestModel = await initGuestAccount();
  await registerService.createGuestAccount(guestModel).then(async res => {
    const data = {
      username: guestModel.login,
      password: guestModel.code || guestModel.emailCode,
      rememberMe: false,
    };

    await axios.post('api/authenticate', data).then(result => {
      const bearerToken = result.headers.authorization;
      if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
        const jwt = bearerToken.slice(7, bearerToken.length);
        localStorage.setItem('ds-authenticationToken', jwt);
      }

      setTimeout(() => {
        window.location.reload();
      }, 200);
    });
  });
}

router.beforeEach(async (to, from, next) => {
  to.meta.fromPath = from.fullPath;
  if (from.fullPath != '/') {
    hideModal();
  }

  const { name, path } = to;

  moveToMobileIntroduce(name, next, path);

  const sessionToken = sessionStorage.getItem('ds-authenticationToken');
  const localToken = localStorage.getItem('ds-authenticationToken');

  const token = sessionToken || localToken;

  if (token) {
    if (isJwtExpired(token)) {
      clearStorage();
      next('/login');
    } else {
      const dsConnectome = localStorage.getItem('localStorageUser');
      const loginName = JSON.parse(dsConnectome)?.login;

      if (loginName && to.name !== 'Login' && to.name !== 'Register') next();
    }
  } else {
    if (!ROUTE_NAME_NOT_CREATE_GUEST?.includes(to.name)) {
      const guestId = localStorage.getItem('_gid');
      if (guestId) {
        await accountService.getTokenByGuestId(guestId).then(res => {
          if (res.data) {
            localStorage.setItem('ds-authenticationToken', res.data);
            setTimeout(() => {
              window.location.reload();
            }, 200);
          } else {
            createGuestAccount();
          }
        });
      } else {
        await createGuestAccount();
      }
    }
  }

  if (!store.getters.authenticated) {
    if (
      to.name !== 'Login' &&
      to.name !== 'Register' &&
      to.name !== 'ReportDetail' &&
      to.name !== 'TopicDetail' &&
      to.name !== 'TermsOfUse' &&
      to.name !== 'PrivacyPolicy'
    ) {
      accountService.retrieveAccount()?.then(res => {
        if (!res) {
          if (to.name === 'Guide') {
            next({ name: 'Guide' });
            return;
          }
        } else {
          next();
        }
      });
    }
  }

  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities)?.then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/forbidden');
      } else {
        next();
      }
    });
  } else if (to.matched.some(record => record.meta.hideForAuth)) {
    const token = localStorage.getItem('ds-authenticationToken') || sessionStorage.getItem('ds-authenticationToken');
    // if (token) {
    if (token && !checkIsGuestAccount()) {
      // if (to.name !== 'Register') {
      next({ path: sessionStorage.getItem('requested-url') || '/' });
      // }
    } else {
      next();
    }
  } else {
    // no authorities, so just proceed
    next();
  }

  if (tokenTimer === undefined) {
    let isCheckResetTk = false;
    tokenTimer = setInterval(() => {
      if (localStorage.getItem('ds-authenticationToken') || sessionStorage.getItem('ds-authenticationToken')) {
        if (localStorage.getItem('ds-authenticationToken')) isCheckResetTk = true;
        axios
          .post('api/refreshToken', null, {
            params: {
              isCheckResetTk,
            },
          })
          .then(res => {
            if (localStorage.getItem('ds-authenticationToken')) {
              localStorage.setItem('ds-authenticationToken', res.data.id_token);
            } else {
              sessionStorage.setItem('ds-authenticationToken', res.data.id_token);
            }
          })
          .catch(error => {
            clearInterval(tokenTimer);
          });
      } else {
        clearInterval(tokenTimer);
      }
    }, 10 * 60 * 1000);
  }

  // if (to.name == 'Detail') {
  //   store.commit('setDetailFeed', true);
  // } else {
  //   store.commit('setDetailFeed', false);
  // }
});

// router.afterEach((to, from) => {
//   if (to.name === 'Discovery') {
//     setTimeout(() => {
//       window.scrollTo(0, store.state.accountStore.scrollTop);
//     }, 0);
//   }
// });

router.onError(error => {
  if (/loading( css)? chunk \d+ failed\./i.test(error.message) && navigator.onLine) {
    window.location.reload();
  }
});
/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    queryClient,
    loginService: () => loginService,
    registerService: () => new RegisterService(),
    userService: () => new UserManagementService(),
    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),

    // userOAuth2Service: () => new UserOAuth2Service(),
    translationService: () => translationService,
    accountService: () => accountService,
    phoneService: () => new PhoneService(),
    // @ts-ignore
    connectomeService: () => new ConnectomeService(store),
    feedService: () => new FeedService(),
    publicService: () => new PublicService(),
    peopleService: () => new PeopleService(),
    recentSearchService: () => new RecentSearchService(),
    principalService: () => new PrincipalService(),
    websocketService: () => websocketService,
    userSettingService: () => new UserSettingService(),
    invitationCodeService: () => new InvitationCodeService(),
    scrapboardManagerService: () => new ScrapboardManagerService(),
    askGooverService: () => new AskGooverService(),
    paymentService: () => new PaymentService(),
    briefingService: () => new BriefingService(),
    reportShareService: () => new ReportShareService(),
    discoveryService: () => new DiscoveryAndReportService(),
    userMyPageService: () => new UserMyPageService(),
    recapService: () => new RecapService(),
    scrapAgentService: () => new ScrapAgentService(),
  },
  i18n,
  store,
});

const eventHub = new Vue();
Vue.mixin({
  data: function () {
    return {
      eventHub: eventHub,
    };
  },
});
